<template>
  <section>
    <el-col
      v-if="buttonList != null && buttonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-input
            v-model="filters.ActivityName"
            placeholder="活动名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.CompanyName"
            placeholder="公司名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.RegisterName"
            placeholder="姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="filters.PhoneNumber"
            placeholder="手机号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="filters.DateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-for="item in buttonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table
      :data="tabData"
      border=""
      v-loading="listLoading"
      ref="table"
      style="width: 100%"
      class="custom-tbl"
    >
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="CompanyName" label="公司名称"></el-table-column>
      <el-table-column
        prop="RegisterName"
        label="姓名"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号码"
        width="150"
      ></el-table-column>
      <el-table-column prop="Email" label="邮箱"></el-table-column>
      <el-table-column prop="StartTime" label="开始时间"></el-table-column>
      <el-table-column prop="EndTime" label="结束时间"></el-table-column>
      <el-table-column prop="SignTime" label="签到时间"></el-table-column>

      <el-table-column
        prop="ActivityName"
        label="活动名称"
        width="300"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="filters.PageIndex"
        :page-size="filters.PageSize"
        :total="filters.total"
        style="float: right"
      ></el-pagination>
    </el-col>
  </section>
</template>

<script>
import { getActivityRecords } from '../../api/api'
import { getButtonList } from '../../promissionRouter'

export default {
  data() {
    return {
      listLoading: false,
      buttonList: [],
      filters: {
        ActivityName: '',
        CompanyName: '',
        RegisterName: '',
        PhoneNumber: '',
        DateRange: [],
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      tabData: [], // 列表绑定数据
      loadingActivityName: false, // 适用活动 加载效果
    }
  },
  components: {
    // Toolbar
  },
  methods: {
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 按钮点击事件传值
    callFunc(item) {
      this[item.Func].apply(this, item)
    },
    // 查询按钮——显示数据
    handleQuery() {
      this.listLoading = true
      getActivityRecords(this.filters).then((res) => {
        if (res.data.success) {
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.tabData = res.data.response.data
          this.listLoading = false
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
          })
        }
      })
    },
  },
  mounted() {
    this.handleQuery()
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    this.buttonList = getButtonList(this.$route.path, routers)
  },
}
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
</style>
